function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingsActguide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.01 48.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,24a2,2,0,0,1,0,4H10a2,2,0,0,1,0-4Zm12-6a2,2,0,0,0-2-2H10a2,2,0,0,0,0,4H26A2,2,0,0,0,28,18ZM10,12H26a2,2,0,1,0,0-4H10a2,2,0,0,0,0,4ZM34,38.9v7.67a1.44,1.44,0,0,1-2.46,1L30,46.05l-1.54,1.54a1.44,1.44,0,0,1-2.46-1V38.9a8,8,0,0,1,6-14.61V10a6,6,0,0,0-6-6H10a6,6,0,0,0-6,6V34a6,6,0,0,0,6,6H20a2,2,0,0,1,0,4H10A10,10,0,0,1,0,34V10A10,10,0,0,1,10,0H26A10,10,0,0,1,36,10V26.77a7.92,7.92,0,0,1-.64,11.16A7.64,7.64,0,0,1,34,38.9ZM34,32a4,4,0,1,0-4,4A4,4,0,0,0,34,32Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingsActguide);
export default __webpack_public_path__ + "static/media/trainings-actguide.852b9783.svg";
export { ForwardRef as ReactComponent };